"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialCard = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _styles = require("./shared/styles");

var _excluded = ["inverse", "icon", "description", "link", "stat"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1l6u76n2"
} : {
  target: "e1l6u76n2",
  label: "Wrapper"
})("display:flex;flex-direction:column;align-items:flex-start;svg{display:block;width:48px;height:48px;}border:1px solid ", function (props) {
  return props.inverse ? 'rgba(255, 255, 255, 0.1)' : _styles.color.border;
}, ";border-radius:", _styles.spacing.borderRadius.small, "px;padding:", _styles.spacing.padding.medium, "px;@media (min-width: ", _styles.breakpoints[1], "px){border:none;border-radius:0;padding:0;}");
var Description = (0, _theming.styled)("p", process.env.NODE_ENV === "production" ? {
  target: "e1l6u76n1"
} : {
  target: "e1l6u76n1",
  label: "Description"
})(_styles.marketing.textLarge, ";letter-spacing:-0.58px;color:", function (props) {
  return props.inverse ? _styles.color.lightest : _styles.color.darkest;
}, ";margin-top:24px;margin-bottom:20px;");
var Stat = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Cardinal, process.env.NODE_ENV === "production" ? {
  target: "e1l6u76n0"
} : {
  target: "e1l6u76n0",
  label: "Stat"
})(process.env.NODE_ENV === "production" ? {
  name: "64oyp3",
  styles: "padding:0;margin-top:24px"
} : {
  name: "64oyp3",
  styles: "padding:0;margin-top:24px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var SocialCard = function SocialCard(_ref) {
  var inverse = _ref.inverse,
      icon = _ref.icon,
      description = _ref.description,
      link = _ref.link,
      stat = _ref.stat,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, (0, _extends2["default"])({
    inverse: inverse
  }, props), icon, /*#__PURE__*/_react["default"].createElement(Description, {
    inverse: inverse
  }, description), /*#__PURE__*/_react["default"].createElement(_designSystem.Button, {
    appearance: inverse ? 'inverseOutline' : 'outline',
    size: "medium",
    isLink: true,
    href: link.href
  }, link.label), /*#__PURE__*/_react["default"].createElement(Stat, {
    size: "small",
    count: stat.count,
    text: stat.label,
    noPlural: true,
    status: inverse ? 'inverse' : 'neutral'
  }));
};

exports.SocialCard = SocialCard;